var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 21,
    fill: "#E6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 27.42H20.89C19.25 27.42 17.92 26.04 17.92 24.34C17.92 23.93 18.26 23.59 18.67 23.59C19.08 23.59 19.42 23.93 19.42 24.34C19.42 25.21 20.08 25.92 20.89 25.92H23.4C24.05 25.92 24.59 25.34 24.59 24.64C24.59 23.77 24.28 23.6 23.77 23.42L19.74 22C18.96 21.73 17.91 21.15 17.91 19.36C17.91 17.82 19.12 16.58 20.6 16.58H23.11C24.75 16.58 26.08 17.96 26.08 19.66C26.08 20.07 25.74 20.41 25.33 20.41C24.92 20.41 24.58 20.07 24.58 19.66C24.58 18.79 23.92 18.08 23.11 18.08H20.6C19.95 18.08 19.41 18.66 19.41 19.36C19.41 20.23 19.72 20.4 20.23 20.58L24.26 22C25.04 22.27 26.09 22.85 26.09 24.64C26.08 26.17 24.88 27.42 23.4 27.42Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28.75C21.59 28.75 21.25 28.41 21.25 28V16C21.25 15.59 21.59 15.25 22 15.25C22.41 15.25 22.75 15.59 22.75 16V28C22.75 28.41 22.41 28.75 22 28.75Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 32.75H19C13.57 32.75 11.25 30.43 11.25 25V19C11.25 13.57 13.57 11.25 19 11.25H25C30.43 11.25 32.75 13.57 32.75 19V25C32.75 30.43 30.43 32.75 25 32.75ZM19 12.75C14.39 12.75 12.75 14.39 12.75 19V25C12.75 29.61 14.39 31.25 19 31.25H25C29.61 31.25 31.25 29.61 31.25 25V19C31.25 14.39 29.61 12.75 25 12.75H19Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsDollar);
export default __webpack_public_path__ + "static/media/statistics-dollar.7bd8e058cc9eb8dd057fe6ed970b279f.svg";
export { ForwardRef as ReactComponent };